import Service from '../../balancer-farm-subgraph.service';
import queryBuilder from './query';
import { UserFlakeInfos, QueryBuilder } from '../../types';

export default class userFlakeInfos {
  service: Service;
  query: QueryBuilder;

  constructor(service: Service, query: QueryBuilder = queryBuilder) {
    this.service = service;
    this.query = query;
  }

  public async get(args = {}, attrs = {}): Promise<UserFlakeInfos[]> {
    const query = this.query(args, attrs);
    const data = await this.service.client.get(query);
    return data.userFlakeInfos;
  }
}
